import { StoreProduct, StoreProductFraction } from '@bofrak-backend/shared';

export const getPopularityScore = (product: StoreProduct): number => {
  if (product.is_parent && product.store_product_fractions?.length > 0) {
    const childrenPopularity = product.store_product_fractions.reduce(
      (sum: number, child: StoreProductFraction) =>
        sum +
        (child.id.toLowerCase() === product.id.toLowerCase()
          ? child.popularity_score || 0
          : 0),
      0,
    );
    return (product.popularity_score || 0) + childrenPopularity;
  }
  return product.popularity_score || 0;
};
